/**
 * Created by Darek on 2016-09-28.
 */
$(document).ready(function () {
    $('.go_top a').click(function () {
        $('body,html').animate({scrollTop: 0}, 1000);
    })
});